import cx from 'classnames';

import styles from './TransparentButton.module.scss';

interface TransparentButtonProps {
  onClick: () => void;
  text: string;
  isSmall?: boolean;
}
const TransparentButton = (props: TransparentButtonProps) => {
  const { onClick, text, isSmall = false } = props;

  return (
    <button
      onClick={onClick}
      className={cx(styles.transparentButton, {
        [styles.small]: isSmall,
      })}
    >
      <span className={styles.buttonText}>{text}</span>
    </button>
  );
};

export default TransparentButton;
